import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';

import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import styles from './notifications-tab.style';
import scss from './notifications-tab.module.scss';
import cookie from 'react-cookies';
import AuthApi from './../../../util/authApi';
import Api from './../../../util/api';
import customFunctions from './../../../util/customFunctions';
import Button from '@mui/material/Button';
import ProfileImg from '../../../assets/images/user-profile.jpg';
import { toggleNotifications } from '../../../actions/layout.actions';

class NotificationsTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageLimit: 10,
            currentPage: 1,
            notifications: [],
            totalCount: 0,
        };
    }

    componentDidMount = async () => {
        this.getNotifications();
    };

    getNotifications = async () => {
        const userId = await cookie.load('userId');
        const { pageLimit, notifications, currentPage } = this.state;
        const endPoint = `${Api.notificationsUrl}?user_id=${userId}&page=${currentPage}&limit=${pageLimit}&sort_by=created_at&sort_direction=descending`;
        const { data } = await AuthApi.getDataFromServer(endPoint);
        if (data) {
            this.setState({
                notifications: [...notifications, ...data.data],
                totalCount: data.paginator.total_count,
                currentPage: currentPage + 1,
            });
        }
    };

    redirectTo = async (e, item) => {
        if (item.ads_id) {
            this.props.toggleNotifications(e);
            window.location = '/advertise/view/' + item.ads_id;
        }
    };

    render() {
        const { classes } = this.props;
        const { notifications, totalCount } = this.state;

        return (
            <div className={scss['portal-notifications-wrapper']}>
                {notifications.map(notification => (
                    <Card
                        className={`${scss['portal-notifications-card']} ${
                            notification.ads_id ? scss['cursor-pointer'] : ''
                        }`}
                        key={notification.id}
                        onClick={e => {
                            e.preventDefault();
                            this.redirectTo(e, notification);
                        }}
                    >
                        <CardContent className="dFlex">
                            <img
                                src={
                                    notification && notification.from_user_image_sizes
                                        ? Api.IMAGE_URL + notification.from_user_image_sizes.small
                                        : ProfileImg
                                }
                                className="notificationImg"
                            />
                            <div className="">
                                <Typography variant="body2" component="small" className="fgName">
                                    {notification.from_user_name
                                        ? customFunctions.capitalizeFirst(notification.from_user_name)
                                        : 'System'}
                                </Typography>
                                <Typography variant="body2" component="h3">
                                    {notification.message.substring(0, 50) +
                                        (notification.message.length > 50 ? '...' : '')}
                                </Typography>
                                <Typography component="span" className="text-right">
                                    {moment(notification.created_at).fromNow()}
                                </Typography>
                            </div>
                        </CardContent>
                    </Card>
                ))}
                {notifications && totalCount > notifications.length && (
                    <div style={{ textAlign: 'center' }}>
                        <Button
                            type="submit"
                            // variant="raised"
                            size="small"
                            //variant="contained"
                            //color="primary"
                            className="button customBtn"
                            onClick={this.getNotifications}
                        >
                            Load More
                        </Button>
                    </div>
                )}
            </div>
        );
    }
}

NotificationsTab.propTypes = {
    classes: PropTypes.shape({}).isRequired,
};

function mapStateToProps(state) {
    return {
        layout: {
            notificationsOpen: state.layout.notificationsOpen,
        },
    };
}

export default compose(
    connect(mapStateToProps, {
        toggleNotifications,
    }),
    withStyles(styles, { withTheme: true }),
)(NotificationsTab);
